<div class="cart-box" (click)="toggleCart()">
  <div class="company-selector-trigger">
    <div class="company-logo-container">
      <ng-container *ngIf="hasValidLogo(selectedCompanyLogo); else defaultIcon">
        <img 
          [src]="selectedCompanyLogo" 
          alt="Company Logo" 
          class="company-logo"
          (error)="onImageError($event)" />
        <div class="company-logo-fallback" style="display: none;">
          <i class="fa fa-building"></i>
        </div>
      </ng-container>
      <ng-template #defaultIcon>
        <div class="company-logo-fallback">
          <i class="fa fa-building"></i>
        </div>
      </ng-template>
    </div>
    <span class="company-name-display" *ngIf="getCurrentCompanyName()">
      {{ getCurrentCompanyName() }}
    </span>
    <span class="company-count-badge" *ngIf="allActivecompanyData?.length">
      {{allActivecompanyData?.length}}
    </span>
  </div>
</div>

<p-dialog 
  [(visible)]="openCart"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '420px', maxWidth: '90vw'}"
  [baseZIndex]="10000"
  styleClass="company-selector-dialog"
  [dismissableMask]="true"
  (onShow)="scrollToSelectedCompany()"
  (onHide)="onDialogClose()">
  
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <h5 class="dialog-title">
        {{ curentLang === 'en' ? 'Select Company' : (curentLang === 'ar' ? 'اختر المصلحة التجارية' : 'בחר חברה') }}
      </h5>
    </div>
  </ng-template>

  <div class="dialog-body">
    <div class="company-list-container">
      <div 
        class="company-item" 
        *ngFor="let item of allActivecompanyData"
        (click)="selectCompany(item)" 
        [ngClass]="{'company-item--active': item.company_id === selectedCompanyId}">
        <div class="company-logo-wrapper">
          <ng-container *ngIf="hasValidLogo(item.logo_url); else noLogo">
            <img 
              class="company-logo-img" 
              [src]="item.logo_url" 
              [alt]="getCompanyDisplayName(item) || 'Company Logo'"
              (error)="onImageError($event)" />
            <div class="company-logo-fallback-item" style="display: none;">
              <span class="company-initials">{{getCompanyInitials(item)}}</span>
            </div>
          </ng-container>
          <ng-template #noLogo>
            <div class="company-logo-fallback-item">
              <span class="company-initials">{{getCompanyInitials(item)}}</span>
            </div>
          </ng-template>
        </div>
        <div class="company-info">
          <span class="company-name">
            {{ getCompanyDisplayName(item) }}
          </span>
        </div>
        <div class="company-check" *ngIf="item.company_id === selectedCompanyId">
          <i class="fa fa-check-circle"></i>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
